/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum IssuanceAllowance {
    ALLOWED = 'allowed',
    DENIED = 'denied',
}
